export default __webpack_public_path__ + "static/media/logo.3abc13d3.svg";